import { devfolioFetch } from "./devfolioApi";

export async function fetchLangsmithBulkUsage({
  projectIds = [],
  startMs,
  endMs,
  days = 7,
}) {
  return devfolioFetch("langsmith/usage/bulk", {
    method: "POST",
    body: JSON.stringify({
      projectIds,
      startMs,
      endMs,
      days,
    }),
  });
}

export async function fetchLangsmithProjectUsage({
  projectId,
  startMs,
  endMs,
  days = 7,
  refresh = false,
}) {
  const params = new URLSearchParams();
  if (projectId) params.set("projectId", projectId);
  if (startMs != null) params.set("startMs", String(startMs));
  if (endMs != null) params.set("endMs", String(endMs));
  if (days != null) params.set("days", String(days));
  if (refresh) params.set("refresh", "1");
  return devfolioFetch(`langsmith/usage?${params.toString()}`);
}
